<template>
  <div v-if="permission">
    <div :class="{ 'list-page-wrap': !embedded }">
      <div class="data-table-title white" v-if="!embedded">
        <div style="display:flex; flex-flow:row; align-items:center">
          <span style="margin-right: 20px;">紹介スライド出力履歴</span>
        </div>
        <div class="flex-space"></div>
        <el-button type="primary" icon="el-icon-refresh-right" @click="loadHistory()" :loading="loading">更新</el-button>
      </div>

      <div :class="[header_notification ? 'header-notification-space-120' : '', 'data-table-message']">
      <div class="data-table-th-140 pointer data-table-th-line" :class="[sort_key === 'created_at' ? 'data-table-sort-active' : '']" @click="sortBy('created_at')">
        出力日時
        <font-awesome-icon
          v-if="sort_key === 'created_at'"
          :icon="['fas', sort_order === 'asc' ? 'arrow-up' : 'arrow-down']"
          style="margin-left:3px;"
        />
      </div>
      <div class="data-table-th-100">SNS</div>
      <div class="data-table-th-ellipsis">施策内容</div>
      <div class="data-table-th-100 pointer data-table-th-line" :class="[sort_key === 'status' ? 'data-table-sort-active' : '']" @click="sortBy('status')">
        ステータス
        <font-awesome-icon
          v-if="sort_key === 'status'"
          :icon="['fas', sort_order === 'asc' ? 'arrow-up' : 'arrow-down']"
          style="margin-left:3px;"
        />
      </div>
      <div class="data-table-th-ellipsis">出力インフルエンサー</div>
      <div class="data-table-th-120 pointer data-table-th-line" :class="[sort_key === 'person_name' ? 'data-table-sort-active' : '']" @click="sortBy('person_name')">
        作成者
        <font-awesome-icon
          v-if="sort_key === 'person_name'"
          :icon="['fas', sort_order === 'asc' ? 'arrow-up' : 'arrow-down']"
          style="margin-left:3px;"
        />
      </div>
      <div class="data-table-th-120"></div>
    </div>

    <div class="data-table-th-loading" v-loading="loading" v-if="loading"></div>
    <div class="data-table-list-nolist" v-else-if="histories.length === 0">
      <img src="../../assets/list_image.png" style="opacity:0.5" alt />
      <div style="font-size:20px; font-weight:700; margin-bottom:15px;">出力履歴がありません</div>
      <div class="data-table-list-nolist-content">リスト画面から紹介スライドを作成すると、ここに表示されます</div>
    </div>

    <div v-else>
      <div class="data-table-list-tr" v-for="history in sortedHistories" :key="history.id">
        <div class="data-table-th-140">{{ formatDate(history.created_at) }}</div>
        <div class="data-table-th-100">
          <el-tooltip v-if="history.sns_type" :content="snsLabel(history.sns_type)" placement="top">
            <div class="data-table-sns-icon-wrap">
              <img :src="snsIconSrc(history.sns_type)" alt="" class="data-table-sns-icon exist" />
            </div>
          </el-tooltip>
          <span v-else>-</span>
        </div>
        <div class="data-table-th-ellipsis">{{ history.measure_content }}</div>
        <div class="data-table-th-100">
          <template v-if="history.status == 2">
            <span>完了</span>
          </template>
          <template v-else-if="history.status == 1">
            <span style="color: #909399">生成中</span>
          </template>
          <template v-else>
            <span style="color: #f56c6c">失敗</span>
          </template>
        </div>
        <div class="data-table-th-ellipsis">
          <el-popover
            v-if="history.influencers && history.influencers.length > 0"
            :ref="'influencerPopover' + history.id"
            placement="top-start"
            trigger="hover"
            popper-class="bio-slide-history-influencer-popover"
            :open-delay="200"
          >
            <div class="bio-slide-history-influencer-popover-content">
              <div
                v-for="(influencer, index) in history.influencers"
                :key="index"
                class="router-link bio-slide-history-influencer-popover-line pointer"
                @click.exact.stop="onInfluencerClick($event, history, influencer, index)"
                @click.ctrl.exact.stop="onInfluencerClick($event, history, influencer, index)"
                @click.meta.exact.stop="onInfluencerClick($event, history, influencer, index)"
              >
                {{ viewInfluencerLabel(influencer) }}
              </div>
            </div>
            <span slot="reference" class="bio-slide-history-influencer-summary pointer">
              {{ influencerSummary(history.influencers) }}
            </span>
          </el-popover>
          <span v-else>-</span>
        </div>
        <div class="data-table-th-120">
          <div class="flex-row bio-slide-history-member">
            <el-image
              v-if="history.person_img_url"
              :src="history.person_img_url"
              class="list-member-profile dropdown"
            >
              <div slot="error" class="list-member-noimg dropdown">{{ history.person_name | firstLetter }}</div>
            </el-image>
            <div v-else-if="history.person_name" class="list-member-noimg dropdown">{{ history.person_name | firstLetter }}</div>
            <div class="bio-slide-history-member-name">{{ history.person_name || "-" }}</div>
          </div>
        </div>
        <div class="data-table-th-120">
          <el-button
            v-if="canDownload(history)"
            type="info"
            size="small"
            @click="openDownload(history)"
          >
            <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right: 5px" />
            ダウンロード
          </el-button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadInfluencerBioSlideHistoryAPI = root + "/api/list/load_influencer_bio_slide_history";

const SNS_LABELS = {
  instagram: "Instagram",
  youtube: "YouTube",
  tiktok: "TikTok",
  twitter: "X",
};

const SNS_ICONS = {
  instagram: require("../../assets/ig_icon.png"),
  youtube: require("../../assets/yt_icon.png"),
  tiktok: require("../../assets/tt_icon.png"),
  twitter: require("../../assets/tw_icon.png"),
};

const INFLUENCER_WINDOW_ROUTE_NAMES = {
  instagram: "influencerDetail",
  youtube: "youtuberDetail",
  tiktok: "tiktokerDetail",
  twitter: "twittererDetail",
};

function influencerRouteParamValue(snsType, influencer) {
  if (snsType === "youtube") {
    return influencer.influencer_id || "";
  }
  return influencer.view_influencer_id || influencer.influencer_id || "";
}

export default {
  name: "influencerBioSlideHistory",
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      histories: [],
      loading: false,
      sort_key: "created_at",
      sort_order: "desc",
    };
  },
  computed: {
    permission() {
      return this.$store.state.permission;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    view_influencer_list_enabled() {
      return this.$store.state.service_plan.view_influencer_list_enabled ? true : false;
    },
    window_switch() {
      return this.$store.state.window_switch;
    },
    sortedHistories() {
      const rows = [...this.histories];
      const direction = this.sort_order === "asc" ? 1 : -1;
      return rows.sort((a, b) => {
        const aValue = this.getSortValue(a, this.sort_key);
        const bValue = this.getSortValue(b, this.sort_key);
        if (typeof aValue === "number" && typeof bValue === "number") {
          return (aValue - bValue) * direction;
        }
        return String(aValue).localeCompare(String(bValue), "ja") * direction;
      });
    },
  },
  mounted() {
    if (!this.view_influencer_list_enabled) {
      if (!this.embedded) {
        this.$router.push("/list");
      }
      return;
    }
    this.loadHistory();
    if (!this.embedded) {
      this.$store.dispatch("changeActive", "list");
    }
  },
  methods: {
    sortBy(column) {
      if (this.sort_key === column) {
        this.sort_order = this.sort_order === "asc" ? "desc" : "asc";
        return;
      }
      this.sort_key = column;
      this.sort_order = "asc";
    },
    getSortValue(history, key) {
      if (key === "status") return Number(history.status) || 0;
      if (key === "person_name") return history.person_name || "";
      if (key === "created_at") return new Date((history.created_at || "").replace(/-/g, "/")).getTime() || 0;
      return "";
    },
    emitLoading(loading) {
      if (!this.embedded) return;
      this.$emit("loading-change", loading);
    },
    loadHistory() {
      this.loading = true;
      this.emitLoading(true);
      const params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      this.axios.post(loadInfluencerBioSlideHistoryAPI, params).then((response) => {
        this.loading = false;
        this.emitLoading(false);
        if (response.data.status === "OK") {
          this.histories = response.data.histories || [];
        }
      }).catch(() => {
        this.loading = false;
        this.emitLoading(false);
        this.$message.error("履歴の取得に失敗しました");
      });
    },
    formatDate(datetime) {
      if (!datetime) return "";
      const d = new Date(datetime.replace(/-/g, "/"));
      if (isNaN(d.getTime())) return datetime;
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    snsLabel(snsType) {
      return SNS_LABELS[snsType] || snsType;
    },
    snsIconSrc(snsType) {
      return SNS_ICONS[snsType] || "";
    },
    viewInfluencerLabel(influencer) {
      return influencer.view_influencer_id || influencer.influencer_id || "";
    },
    onInfluencerClick(event, history, influencer, index) {
      this.closeInfluencerPopover(history.id);
      const snsType = history.sns_type;
      const paramValue = influencerRouteParamValue(snsType, influencer);
      if (!paramValue) return;
      const payload = { snsType, paramValue, index };
      const openWindow = event.ctrlKey || event.metaKey || !this.window_switch;
      if (openWindow) {
        this.openInfluencerNewWindow(payload);
        return;
      }
      if (this.embedded) {
        this.$emit("open-influencer-drawer", payload);
        return;
      }
      this.openInfluencerNewWindow(payload);
    },
    closeInfluencerPopover(historyId) {
      const ref = this.$refs[`influencerPopover${historyId}`];
      const popover = Array.isArray(ref) ? ref[0] : ref;
      if (popover && typeof popover.doClose === "function") {
        popover.doClose();
      }
    },
    openInfluencerNewWindow({ snsType, paramValue }) {
      const toName = INFLUENCER_WINDOW_ROUTE_NAMES[snsType];
      if (!toName || !paramValue) return;
      const routeData = this.$router.resolve({
        name: toName,
        params: {
          account_name: paramValue,
          channel_id: paramValue,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    influencerSummary(influencers) {
      if (!influencers || influencers.length === 0) return "-";
      const labels = influencers.map((i) => this.viewInfluencerLabel(i));
      if (labels.length <= 2) return labels.join("、");
      return `${labels.slice(0, 2).join("、")}、他${labels.length - 2}名`;
    },
    canDownload(history) {
      return Number(history.status) === 2 && !!this.downloadUrl(history);
    },
    downloadUrl(history) {
      return history.file_path || "";
    },
    openDownload(history) {
      const url = this.downloadUrl(history);
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
  filters: {
    firstLetter(val) {
      if (!val) return "";
      return val.slice(0, 1);
    },
  },
};
</script>

<style scoped>
.bio-slide-history-member {
  align-items: center;
}

.bio-slide-history-member-name {
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.bio-slide-history-influencer-popover {
  max-width: 240px;
}

.bio-slide-history-influencer-popover-content {
  display: flex;
  flex-direction: column;
}

.bio-slide-history-influencer-popover-line {
  display: block;
  line-height: 1.5;
}

.bio-slide-history-influencer-popover-line + .bio-slide-history-influencer-popover-line {
  margin-top: 4px;
}
</style>
